import { AfterViewChecked, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'ng-jhipster';
import { Observable, Subscription } from 'rxjs';
import { Principal } from '../../shared/auth/principal.service';
import { UtilsService } from '../../shared/utils/utils.service';
import { CampaignService } from '../campaign/campaign.service';
import { MasterProposal, PropositionStatus } from '../master-proposal/master-proposal.model';
import { Master } from '../master/master.model';
import { MasterService } from '../master/master.service';
import { Saisine } from './saisine.model';
import { SaisineService } from './saisine.service';


@Component({
    selector: 'jhi-saisine-search-solutions',
    templateUrl: './saisine-search-solutions.component.html'
})
export class SaisineSearchSolutionsComponent implements OnInit, OnChanges, AfterViewChecked, OnDestroy {
    @Input() saisine: Saisine;
    @Input() nbDemandesHorsRegion: number;

    @Output() saisineChange = new EventEmitter();

    isSaving: boolean;

    // Referentiel de masters
    masters: Master[]; // NE PAS SUPPRIMER D'ELEMENTS DE CETTE LISTE (evite de faire un rechargement de cette liste si utilisée)
    mastersFilteredByMention: Master[];
    // Referentiel des masters trié, filtré
    mastersFiltered: Master[];

    // Table search solutions
    @ViewChild('dtSearchSolutions') dtSearchSolutions;
    initializedDtSearchSolutions: boolean;
    multiSortMetaDtSearchSolutions: any[];

    userAcademicRegionLabel: string;

    // Bouton de super filtre
    isFilteredByMention = false;
    isFilteredBySchool: boolean;
    isFilteredByAcademicRegionLabel: boolean;

    // Panier
    mastersInCart: Master[];

    private subscription: Subscription = new Subscription();

    constructor(
        private saisineService: SaisineService,
        private alertService: AlertService,
        public principal: Principal,
        public masterService: MasterService,
        public utilsService: UtilsService,
        private modalService: NgbModal,
        private campaignService: CampaignService) { }

    ngOnInit() {
        this.mastersInCart = [];
        this.loadMasters();
        this.initSortDtSearchSolutions();
        this.userAcademicRegionLabel = this.principal.getAcademicRegionLabel();
    }

    ngAfterViewChecked() {
        if (this.dtSearchSolutions && !this.initializedDtSearchSolutions) {
            // wait a tick to avoid one-time devMode
            // unidirectional-data-flow-violation error
            setTimeout(_ => this.onInitFiltersDtSearchSolutions(this.dtSearchSolutions));
            this.initializedDtSearchSolutions = true;
        }
    }


    loadMasters(): void {
        this.subscription.add(Observable.combineLatest(
            this.masterService.query({ 'campaign': this.campaignService.getCurrentCampaignYear() }),
            this.masterService.getMastersFilteredByMention(this.saisine.licenceTitle)
        ).subscribe(([masters, mastersByMention]) => {
            this.mastersFiltered = this.masters = this.deleteMasterProposalsFromMasterReferenciel(masters.json() as Master[]);
            this.mastersFilteredByMention = this.masters.filter(m => !!mastersByMention.find(mBM => mBM.masterInm === m.masterInm && mBM.masterSchoolUai === m.masterSchoolUai));
        }));
    }

    deleteMasterProposalsFromMasterReferenciel(arrayToFilter: Master[]): Master[] {
        // Je recupere les master porposals, pour chaque je verifie si un des master du referentiel en fait partie
        // des qu'il le trouve on recupere son index et on le supprime de la liste du referentiel.
        this.saisine.masterProposals.forEach(mp => {
            if (PropositionStatus.REJECTED !== mp.status) {
                arrayToFilter.filter(m => mp.master.id === m.id).forEach(master => {
                    arrayToFilter.splice(arrayToFilter.indexOf(master), 1);
                });
            }
        });
        return this.principal.hasAnySyncAuthority(['ROLE_ACADEMICREGIONRECTOR', 'ROLE_ACADEMICRECTOR']) ? arrayToFilter.filter(master => master.availablePlaces > 0) : arrayToFilter;
    }

    ngOnChanges(saisine) {
        if (this.masters) {
            this.mastersFiltered = this.masters = this.deleteMasterProposalsFromMasterReferenciel(this.masters);
        }
        if (this.mastersFilteredByMention) {
            this.mastersFilteredByMention = this.deleteMasterProposalsFromMasterReferenciel(this.mastersFilteredByMention);
        }
    }



    // Debut - Tableau de recherche de solution d'affectations


    initSortDtSearchSolutions() {
        this.multiSortMetaDtSearchSolutions = [];
        if (this.principal.hasSyncAuthority('ROLE_ACADEMICREGIONRECTOR')) {
            this.multiSortMetaDtSearchSolutions.push({ field: 'academyLabel', order: 1 });
            this.multiSortMetaDtSearchSolutions.push({ field: 'masterSchoolName', order: 1 });
            this.multiSortMetaDtSearchSolutions.push({ field: 'formationLabel', order: 1 });
        }
        if (this.principal.hasSyncAuthority('ROLE_ACADEMICRECTOR')) {
            this.multiSortMetaDtSearchSolutions.push({ field: 'academicRegionLabel', order: 1 });
            this.multiSortMetaDtSearchSolutions.push({ field: 'academyLabel', order: 1 });
            this.multiSortMetaDtSearchSolutions.push({ field: 'formationLabel', order: 1 });
        }
        if (this.principal.isSchoolProfile()) {
            this.multiSortMetaDtSearchSolutions.push({ field: 'formationLabel', order: 1 });
        }
    }


    onInitFiltersDtSearchSolutions(dtSearchSolutions) {
        dtSearchSolutions.reset();
        dtSearchSolutions.filters['masterInm'] = { matchMode: 'contains', value: '' };
        dtSearchSolutions.filters['formationLabel'] = { matchMode: 'contains', value: '' };
        dtSearchSolutions.filters['masterSchoolName'] = { matchMode: 'contains', value: '' };
        dtSearchSolutions.filters['residualVacantPlaces'] = { matchMode: 'contains', value: '' };
        dtSearchSolutions.filters['residualVacantPlacesLastModificationDate'] = { matchMode: 'contains', value: '' };
        dtSearchSolutions.filters['academyLabel'] = { matchMode: 'contains', value: '' };
        dtSearchSolutions.filters['academicRegionLabel'] = { matchMode: 'contains', value: '' };

        if (this.principal.hasSyncAuthority('ROLE_ACADEMICREGIONRECTOR')) {
            let academicRegionLabel = this.principal.getAcademicRegionLabel();
            if (academicRegionLabel) {
                dtSearchSolutions.filters['academicRegionLabel'] = { matchMode: 'contains', value: academicRegionLabel };
            }
        }
        if (this.principal.hasSyncAuthority('ROLE_ACADEMICRECTOR')) {
            let academyLabel = this.principal.getAcademyLabel();
            if (academyLabel) {
                dtSearchSolutions.filters['academyLabel'] = { matchMode: 'contains', value: academyLabel };
            }
        }
        // Tri sur académie, établissement et intitulé de formation
        dtSearchSolutions._filter();
    }


    reapplyInitSortFilterDtSearchSolutions(): void {
        this.mastersFiltered = this.masters;
        this.isFilteredByMention = false;
        this.initSortDtSearchSolutions();
        this.isFilteredBySchool = false;
        this.isFilteredByAcademicRegionLabel = false;
        if (this.initializedDtSearchSolutions) {
            this.onInitFiltersDtSearchSolutions(this.dtSearchSolutions);
            this.dtSearchSolutions.multiSortMeta = this.multiSortMetaDtSearchSolutions;
            this.dtSearchSolutions.sortMultiple();
        }
    }


    isAtLeastOneSelected(): boolean {
        if (this.mastersInCart.length > 0) {
            return this.mastersInCart.map(master => master.selected === true).reduce((acc, curr) => acc || curr);
        } else {
            return false;
        }
    }

    // Super filtres associés
    filterByMention() {
        this.mastersFiltered = this.mastersFilteredByMention;
        this.isFilteredByMention = true;
    }

    unFilterByMention() {
        this.mastersFiltered = this.masters;
        this.isFilteredByMention = false;
    }

    filterByAcademicRegion() {
        this.dtSearchSolutions.filters['academicRegionLabel'] = { matchMode: 'contains', value: this.saisine.licenceAcademicRegionLabel };
        this.dtSearchSolutions._filter();
        this.isFilteredByAcademicRegionLabel = true;
    }

    filterBySchool() {
        this.dtSearchSolutions.filters['masterSchoolName'] = { matchMode: 'contains', value: this.saisine.licenceSchoolLabel };
        this.dtSearchSolutions._filter();
        this.isFilteredBySchool = true;
    }


    addMasterToCart(master) {
        master.inCart = true;
        this.mastersInCart.push(master);
    }

    // Fin - tableau de recherche de solutions d'affectations



    submitCart(content) {
        this.isSaving = true;
        let masterProposals = [];
        this.mastersInCart.filter(m => m.selected).forEach(m => {

            // Create a master proposal
            let mp: any;
            mp = MasterProposal.prototype.masterToMasterProposal(m);
            if (this.principal.hasSyncAuthority('ROLE_ACADEMICREGIONRECTOR')) {
                mp.status = PropositionStatus.SUBMITTED;
            } else if (this.principal.hasSyncAuthority('ROLE_ACADEMICRECTOR')) {
                mp.status = PropositionStatus.SUBMITTED;
            } else if (this.principal.isSchoolProfile()) {
                mp.status = PropositionStatus.ACCEPTED;
            }

            masterProposals.push(mp);
        });

        // En tant que school une popin s'affiche
        if (this.principal.isSchoolProfile()) {
            this.submitAdmission(content, masterProposals);
        } else {
            this.saisineService.addMasterProposal(this.saisine.id, masterProposals).subscribe(
                this.onSaveSuccess,
                this.onSaveError
            );
        }
    }

    // this binding
    onSaveSuccess = () => {
        this.isSaving = false;

        // Suppression des master proposal du panier
        this.mastersFiltered.forEach(mf => {
            mf.inCart = false;
            mf.selected = false;
        });
        this.mastersInCart = [];
        this.saisineChange.emit();
    }

    // this binding
    onSaveError = (error) => {
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.utilsService.scrollToTop();
        this.alertService.error(error.message, null, null);
        if (error.headers && error.headers._headers && error.headers._headers.get('x-tmmsaisineapp-error') && error.headers._headers.get('x-tmmsaisineapp-error').includes('error.saisineModifiedMeanwhile')) {
            this.onSaveSuccess();
        }
    }

    submitAdmission(content, masterProposals: MasterProposal[]) {
        this.modalService.open(content).result.then((result) => {
            this.saisineService.addMasterProposal(this.saisine.id, masterProposals).subscribe(
                this.onSaveSuccess,
                this.onSaveError
            );
        }, (reason) => {
            this.isSaving = false;
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    // If the number of proposals from other region at status "soumise" exceed the limit, current master can not be added
    isDisableAsNbOutOfRegionProposalsExceedLimit(master: Master) {
        return master.academicRegionLabel !== this.saisine.licenceAcademicRegionLabel
            && !master.selected
            && this.isNbOutOfRegionProposalsExceedLimit();
    }

    // If the number of proposals from other region at status "soumise" exceed the limit, no more proposals can be added
    isNbOutOfRegionProposalsExceedLimit() {
        return !this.principal.isSchoolProfile()
            && (this.nbDemandesHorsRegion !== null)
            && (this.nbRemainingProposals() - this.mastersInCart.filter(_ => _.academicRegionLabel !== this.saisine.licenceAcademicRegionLabel && _.selected).length <= 0);
    }
    nbRemainingProposals(): number {
        const calcul = this.nbDemandesHorsRegion - this.saisine.masterProposals.filter(_ => _.master.academicRegionLabel !== this.saisine.licenceAcademicRegionLabel && _.status === PropositionStatus.SUBMITTED).length;
        return calcul < 0 ? 0 : calcul;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine-search-solutions.component.ts